import React, { useState } from 'react';
import {
  Alert,
  IconButton,
  Snackbar as MuiSnackbar,
  SxProps,
  Theme,
} from '@mui/material';
import { AlertColor } from '@mui/material/Alert/Alert';
import { useDispatch } from 'react-redux';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';
import { snackbarActions } from '@/redux';
import Modal from '@components/common/modal/Modal';
import { useSelector } from '@redux/store/store';

const Snackbar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { open, autoHideDuration, message, detailedMessage, severity } = useSelector(
    (state) => state.snackbar,
  );
  const [detailModalOpen, setDetailModalOpen] = useState<boolean>(false);

  const severityColorMap = new Map<AlertColor, string>([
    ['error', '#d32f2f'],
    ['success', '#2e7d32'],
    ['info', '#0288d1'],
    ['warning', '#ed6c02'],
  ]);

  const onClose = () => {
    dispatch(snackbarActions.closeSnackbar());
  };
  const onOpenDetails = () => {
    setDetailModalOpen(true);
  };

  const getStyle = (): SxProps<Theme> => {
    return {
      border: `2px solid ${severityColorMap.get(severity)}`,
      borderRadius: '10px',
    };
  };

  return (
    <>
      <MuiSnackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        sx={getStyle()}
      >
        <Alert
          onClose={onClose}
          severity={severity}
          sx={{ width: '100%', alignItems: 'center' }}
          action={
            detailedMessage && (
              <IconButton
                size='small'
                aria-label=''
                color='inherit'
                onClick={onOpenDetails}
                sx={{
                  padding: 0,
                }}
              >
                <MoreHorizIcon />
              </IconButton>
            )
          }
        >
          {message}
        </Alert>
      </MuiSnackbar>
      {detailedMessage && (
        <Modal
          open={detailModalOpen}
          onClose={() => setDetailModalOpen(false)}
          title={t('error.error_modal_title')}
        >
          <div style={{ whiteSpace: 'pre-wrap', width: '100%' }}>{detailedMessage}</div>
        </Modal>
      )}
    </>
  );
};

export default Snackbar;
